import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Data,
  Params,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ImageCachePipe } from '../pipes/ImageCachePipe';

declare global {
  interface Window {
    gtag: any;
  }
}

@Injectable({ providedIn: 'root' })
export class RouteDataService {
  constructor(
    private router: Router,
    private titleService: Title,
    private metaService: Meta,
    private cachePipe: ImageCachePipe
  ) { }

  get(): void {
    const data = this.getRouteSnapshot();
    var routeData = { data: data.data, params: data.params };
    var titleToSet = 'PlateX - the UKs Private Plate Portal'; // base
    var description =
      'Find your perfect private number plate from 40 dealers, the DVLA and private sellers! Free price comparison on 73 million personalised plates.';
    var image = this.cachePipe.transform('https://cdn.platex.co.uk/banners/PLATEX_R8.jpg');
    var shouldIndex = true;
    if (routeData.data['title'] != undefined)
      titleToSet = this.constructString(routeData.data['title'], routeData);

    if (routeData.data['image'] != undefined)
      image = this.constructString(this.cachePipe.transform(routeData.data['image']), routeData);

    if (routeData.data['index'] === false) {
      shouldIndex = false;
    }

    if (routeData.data['description'] != undefined)
      description = this.constructString(
        routeData.data['description'],
        routeData
      );

    this.setMeta(titleToSet, description, image, shouldIndex);
  }

  public setMeta(title: string, description: string, image: string, shouldIndex: boolean): void {
    window.gtag('event', 'page_view', {
      page_title: title,
    });
    this.titleService.setTitle(title);
    this.metaService.addTags([
      { name: 'description', content: description },
      { name: 'og:description', content: description },
      { name: 'og:image', content: image },
    ]);

    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ name: 'image', content: image });
    this.metaService.updateTag({ name: 'og:image', content: image });
    this.metaService.updateTag({
      name: 'og:description',
      content: description,
    });

    if (shouldIndex && window.location.href.indexOf('dev.platex') === -1) {
      this.metaService.removeTag("name='robots'");
    } else {
      this.metaService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    }
  }

  private constructString(
    text: string,
    routeInfo: { data: Data; params: Params }
  ): string {
    const r = new RegExp('(?<={)(.*?)(?=})');
    const regexResults = r.exec(text);

    var builtText = text;
    if (regexResults != null) {
      regexResults.forEach((key: string) => {
        builtText = builtText.replace(
          `{${key}}`,
          (routeInfo.params[key] as string).toUpperCase()
        );
      });
    }

    return builtText;
  }

  private getRouteSnapshot(): ActivatedRouteSnapshot {
    let route: ActivatedRoute = this.router.routerState.root;
    while (route!.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot;
  }
}
